import { render, staticRenderFns } from "./UserCircleIcon.vue?vue&type=template&id=c05287c0&scoped=true&"
import script from "./UserCircleIcon.vue?vue&type=script&lang=js&"
export * from "./UserCircleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05287c0",
  null
  
)

export default component.exports